<template>
  <div class="fob-compact-patent">
    <div>
      <span v-if="organizationalUnit">{{organizationalUnit}}</span>
    </div>
    <div>
      <span v-if="title" class="has-text-weight-bold">{{title}}</span>
      <span v-if="publicationNumber">({{publicationNumber}})</span>
    </div>
    <div v-if="mainInventor">
      <span>{{mainInventor}}</span>
    </div>
    <div v-if="priorityDate">
      <span><translate class="is-italic">Patent.compact.datumDerPrioritaetsbegruendendenErstanmeldung</translate>: {{priorityDate}}</span>
    </div>
  </div>
</template>

<script>
import CompactViewHelper from '@/components/mixins/CompactViewHelper'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'

export default {
  name: 'fob-patent-compact',
  mixins: [CompactViewHelper, DateTimeHelper],
  props: ['schema', 'data'],
  computed: {
    title () {
      return this.data.titel
    },
    mainInventor () {
      return this.fullName((this.data.haupterfinder && this.data.haupterfinder[0]) || {})
    },
    organizationalUnit () {
      return this.data.organisationseinheit.name
    },
    priorityDate () {
      return this.asDate(this.data.datumDerPrioritaetsbegruendendenErstanmeldung)
    },
    publicationNumber () {
      return this.data.veroeffentlichungsnummer
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/compact/Patent.vue